import {
  STATUS_DELETED,
  STATUS_DRAFT,
  STATUS_EXPIRED,
  STATUS_MORE_INFO,
  STATUS_NEW,
  STATUS_PENDING,
  STATUS_PENDING_BC,
  STATUS_PENDING_CFO,
  STATUS_PENDING_CMO,
  STATUS_PENDING_DR,
  STATUS_PENDING_FM,
  STATUS_PENDING_LEGAL,
  STATUS_PENDING_PARTNER,
  STATUS_PENDING_TL,
  STATUS_PENDING_VP,
  STATUS_REJECTED,
  STATUS_SIGNED,
  STATUS_TERMINATED,
} from 'scenes/FinancePage/IO/constants';

export const COLOR_MAP = new Map([
  [STATUS_NEW, 'success'],
  [STATUS_DELETED, 'inactive'],
  [STATUS_REJECTED, 'danger'],
  [STATUS_TERMINATED, 'danger'],
  [STATUS_EXPIRED, 'danger'],
  [STATUS_DRAFT, 'processing'],
  [STATUS_MORE_INFO, 'info'],
  [STATUS_PENDING_LEGAL, 'processing'],
  [STATUS_PENDING, 'processing'],
  [STATUS_PENDING_TL, 'processing'],
  [STATUS_PENDING_DR, 'processing'],
  [STATUS_PENDING_VP, 'processing'],
  [STATUS_PENDING_BC, 'processing'],
  [STATUS_PENDING_FM, 'processing'],
  [STATUS_PENDING_CFO, 'processing'],
  [STATUS_PENDING_PARTNER, 'processing'],
  [STATUS_SIGNED, 'success'],
  [STATUS_PENDING_CMO, 'processing'],
]);
